import React from 'react';
// import utils from 'shared/helpers/utils';
import './Banner.scss';

// import MobileBanner from 'assets/images/heroGraphic.png';

const Banner = props => (
  <div className="banner" onDoubleClick={() => props.onDoubleClick()}>
    {/* <img src={`${utils.baseUrl}/heroGraphic.png`} alt="homebanner" /> */}
    {/* style={{ backgroundImage: `url('${utils.baseUrl}/heroGraphic.png')` }} */}
    <article>
      <div className="board">
        {props.msg}
      </div>
      <p>{props.intro}</p>
    </article>
  </div>
);

export default Banner;
